export default __webpack_public_path__ + "static/media/organiImage.733e7617.svg";